import { gql, useQuery } from "@apollo/client";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Button, Menu, MenuItem } from "@mui/material";
import { useContext, useState } from "react";
import GlobalContext from "../../global-context";

export default function CurrencySwitcher() {
  const globalContext = useContext(GlobalContext);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const { data, loading, error } = useQuery<currenciesResult>(GET_CURRENCIES);
  if (loading) return <></>;
  if (error) return <>error</>;

  const currencies = data
    ? data.__type.enumValues.map((enumValue) => enumValue.name)
    : [];

  return (
    <>
      <Button
        sx={{ color: "white", fontWeight: "bold" }}
        endIcon={<KeyboardArrowDownIcon />}
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        {globalContext.currency}
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={() => setAnchorEl(null)}>
        {currencies.map((currency) => (
          <MenuItem
            key={currency}
            sx={{ fontSize: "14px" }}
            onClick={() => {
              localStorage.setItem("currency", currency);
              globalContext.setCurrency(currency);
              setAnchorEl(null);
            }}
          >
            {currency}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

const GET_CURRENCIES = gql`
  query GetCurrencies {
    __type(name: "Currency") {
      enumValues {
        name
      }
    }
  }
`;

type currenciesResult = {
  __type: {
    enumValues: {
      name: string;
    }[];
  };
};
